// Static timesheet status constants

export const TIMESHEET_STATUSES = [
	{
		timesheet_status_mstr_key: 1,
		display_name: "New",
		value: "new",
		color_code: "#6B6C6D",
	},
	{
		timesheet_status_mstr_key: 2,
		display_name: "Approval in Process",
		value: "approval_in_process",
		color_code: "#C87700",
	},
	{
		timesheet_status_mstr_key: 4,
		display_name: "Approved",
		value: "approved",
		color_code: "#28A745",
	},
	{
		timesheet_status_mstr_key: 9,
		display_name: "Hold",
		value: "hold",
		color_code: "#546E7A",
	},
	{
		timesheet_status_mstr_key: 5,
		display_name: "Comp Admin Review",
		value: "pending_comp_admin_review",
		color_code: "#00A1E4",
	},
	{
		timesheet_status_mstr_key: 6,
		display_name: "Ready for Payroll Processing",
		value: "ready_for_payroll_processing",
		color_code: "#E4A80C",
	},
	{
		timesheet_status_mstr_key: 7,
		display_name: "Sent to Payfile",
		value: "sent_to_payroll",
		color_code: "#15B177",
	},
	{
		timesheet_status_mstr_key: 3,
		display_name: "Rejected",
		value: "rejected",
		color_code: "#EC5757",
	},
];

// Get status by timesheet_status_mstr_key
export const getStatusByKey = (key) => 
	TIMESHEET_STATUSES.find(s => s.timesheet_status_mstr_key === key);

// Get status by value (e.g., "new", "approved", "rejected")
export const getStatusByValue = (value) => 
	TIMESHEET_STATUSES.find(s => s.value === value);

export const getStatus = () => TIMESHEET_STATUSES;

const applyFeatureFlags = (list, featureFlags) => {
	if (!featureFlags) return list
	return list.filter((s) => {
		if (s.value === "hold" && featureFlags.holdEnabled === false) return false
		return true
	})
}

export const getProviderStatuses = (featureFlags) => {
	return applyFeatureFlags(
		TIMESHEET_STATUSES.filter((s) => s.value !== "approved"),
		featureFlags
	)
}

export const getApproverStatuses = () => {
	return TIMESHEET_STATUSES.filter(s => s.value.includes(["new", "approved", "rejected"]))
}

export const getCompAdminStatuses = (featureFlags) => {
	return applyFeatureFlags(
		TIMESHEET_STATUSES.filter((s) => s.value !== "approved"),
		featureFlags
	)
}